import * as React from "react";
import CreditCard from './CreditCard';
import CreditCardMint from './CreditCardMint';
import CreditCardUATP from './CreditCardUATP';
import CreditCardFC from "./organisation/CreditCardFC";

class CardView extends React.Component {
	render() {		
		const record = this.props.record !== 'undefined' ? JSON.parse(this.props.record) : '';	

		if (record !== '') {
			//FlightCentre use a custom card view component to display details of the shared virtual card.
			if(record.cardView === "FlightCentre"){
				const currency = record.provider === "WEX" ? record.localCurrency : record.currencyCodes[0];

				return <CreditCardFC 					
					number={record.cardNumber}
					name={record.cardHolderName}
					expiry={record.cardExpiry}
					cvv={record.cardSecurityCode}
					type={record.cardType}
					cardLimit={record.cardLimit}
					currency={currency}
					providerId={record.providerId}
					userDefinedFields={record.userDefinedFields}
					kuggarId={record.kuggarId}
					dateTimeUtc={record.dateTimeUtc}
				/>
			} else { 
				if (record.provider === 'Kuggar'){
				return <CreditCardUATP
					number={record.cardNumber}
					name={record.cardHolderName}
					expiry={record.cardExpiry}
					cvv={record.cardSecurityCode}
					type={record.cardType}
				/>;
				} else if (record.provider === 'Mint') {
					return <CreditCardMint
						number={record.cardNumber}
						name={record.cardHolderName}
						expiry={record.cardExpiry}
						cvv={record.cardSecurityCode}
						type={record.cardType}
					/>;
				} else {
					return <CreditCard
						number={record.cardNumber}
						name={record.cardHolderName}
						expiry={record.cardExpiry}
						cvv={record.cardSecurityCode}
						type={record.cardType}
					/>;
				}
			}
		}
	}
}

export default CardView;